module.exports = __webpack_public_path__ + "static/media/1-4-3.2cbb1309.png";